import * as Yup from "yup";

export const initialValues = {
  grade: "",
  startDate: "",
  activities: "",
  description: "",
  institution: "",
  fieldOfStudy: "",
  qualification: "",
  graudationDate: "",
  educationDetailsList: null,
};

export const validationSchema = Yup.object().shape({
  grade: Yup.string().notRequired(),
  startDate: Yup.date().required("Start date is required"),
  activities: Yup.string().notRequired(),
  description: Yup.string().notRequired(),
  institution: Yup.string().required("Institution is required"),
  fieldOfStudy: Yup.string().required("Field of study is required"),
  qualification: Yup.string().required("Qualification is required"),
  graudationDate: Yup.date().required("Graduation date is required"),
});
